/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var KonturBonusSignIcon16Light = forwardRef('KonturBonusSignIcon16Light', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M8 1a.5.5 0 0 0-1 0v2H5a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h2v2a.5.5 0 0 0 1 0v-2h1a3 3 0 1 0 0-6H5V4h5.5a.5.5 0 0 0 0-1H8V1ZM5 12V8h4a2 2 0 1 1 0 4H5Z" })));
});
